export const store = {
  reviewMode: false,
  showErrors: false,
  application: {},
  errors: {},
  universities: [],
};
